<template>
  <div :class="classArr" v-bind="attrs" v-on="listeners" v-show="show">
    <slot />
  </div>
</template>

<script>
import mixin from '../mixins/child';

/**
 * @vue-prop {Array} classes - css class
 * @vue-prop {String} onClass - 활성화 css class명
 * @vue-prop {Boolean} same - TToggle의 selectedIndex와 자신의 index 같은지 유무 반환
 * @vue-prop {Boolean} show - onClass 존재 시 활성화 유무 혹은 same 통한 활성화 유무 반환
 * @vue-computed {Array} classArr - onClass 속성과 병합된 css클래스
 */
export default {
  name  : 't-toggle-content',
  mixins: [mixin],
  props : {
    classes: {
      type   : Array,
      default: () => []
    },
    onClass: {
      type   : String,
      default: null
    }
  },
  computed: {
    same() {
      return this.selectedIndex === this.index;
    },
    show() {
      return this.calcOnClass ? true : this.same;
    },
    classArr() {
      const activate = this.calcOnClass && this.same ? this.calcOnClass : '';

      return ['t-toggle__content', ...this.classes, activate];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
